import Cookies from 'js-cookie';

const parsePriceValue = (value) => {
  if (value === null || value === undefined || value === '') return null;

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === 'string') {
    const normalizedValue = value.replace(/[^\d,.-]/g, '').trim();

    if (!normalizedValue) return null;

    let parsedValue = Number(normalizedValue);

    if (normalizedValue.includes(',')) {
      parsedValue = Number(normalizedValue.replace(/\./g, '').replace(',', '.'));
    } else if (normalizedValue.includes('.')) {
      const parts = normalizedValue.split('.');

      if (parts.length > 2 || parts[1]?.length === 3) {
        parsedValue = Number(parts.join(''));
      }
    }

    return Number.isNaN(parsedValue) ? null : parsedValue;
  }

  return null;
};

const hasPromotionalPrice = (value) => {
  const parsedValue = parsePriceValue(value);

  if (parsedValue === null) {
    return Boolean(value);
  }

  return parsedValue > 0;
};

const formatProductPrice = (value) => {
  if (value === null || value === undefined || value === '') return '';

  if (typeof value === 'string' && value.includes('R$')) {
    return value.trim();
  }

  const parsedValue = parsePriceValue(value);

  if (parsedValue === null) {
    return String(value).trim();
  }

  return parsedValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const getWhatsappUrl = (product = null) => {
  let message = '';

  if (product) {
    const baseMessage = (Cookies.get('whatsapp_product_message') || '').trim();
    const selectedPrice = hasPromotionalPrice(product.promotionalPrice)
      ? product.promotionalPrice
      : product.price;
    const formattedPrice = formatProductPrice(selectedPrice);
    const productDescription = formattedPrice
      ? `${product.name} no valor de ${formattedPrice}`
      : product.name;

    message = [baseMessage, productDescription].filter(Boolean).join(' ');
  } else {
    message = `${Cookies.get('whatsapp_message') || ''}`;
  }

  const encodedMessage = encodeURIComponent(message);
  return `${Cookies.get('whatsapp_link')}?text=${encodedMessage}`;
};
